/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/* eslint-disable */
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/es';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import auth from "./auth";

function renderApp() {
  // axios.baseURL = "https://dev-backend.pjm.gob.ar/ged-backend-cloud-master/";

  // axios.interceptors.response.use(
  //   function (response) {
  //     // Do something with response data

  //     if (response.data.code === "401") {
  //       //should be checking this on frontend not back
  //       // alert("ERROR")
  //       // alert(response.data.status.error)
  //     }
  //     return response;
  //   },
  //   function (error) {
  //     // Do something with response error
  //     return Promise.reject(error);
  //   }
  // );

  ReactDOM.render(
    <BrowserRouter>

      <MaterialUIControllerProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
          <App />
          </LocalizationProvider>
      </MaterialUIControllerProvider>

    </BrowserRouter>,
    document.getElementById("root")
  );
}

function renderLoginGate() {
  ReactDOM.render(
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "1rem",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <h1 style={{ margin: 0 }}>Sorteos</h1>
      <p style={{ margin: 0, color: "#555" }}>Iniciá sesión con tu cuenta institucional</p>
      <button
        type="button"
        style={{
          padding: "0.75rem 1.5rem",
          fontSize: "1rem",
          cursor: "pointer",
        }}
        onClick={() => {
          auth.signIn().catch((err) => {
            console.error("Sign-in failed", err);
            alert("No se pudo iniciar sesión. Reintentá.");
          });
        }}
      >
        Iniciar sesión
      </button>
    </div>,
    document.getElementById("root")
  );
}

// El observer decide qué mostrar y también cubre el retorno del popup.
let rendered = null;

auth.watchSession((user) => {
  const next = user ? "app" : "login";
  if (next === rendered) {
    return;
  }
  rendered = next;

  if (user) {
    console.info("Authenticated", user.email);
    renderApp();
  } else {
    renderLoginGate();
  }
});
